import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function DiscordCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const role = params.get("state") || "member";

    (async () => {
      if (!code) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/discord/callback", { code, role });
        setUser(data);
        navigate(data.role === "creator" ? "/creator" : "/member", { replace: true });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/auth", { replace: true }), 2200);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] grain">
      <div className="flex flex-col items-center gap-4">
        {!error ? (
          <>
            <div className="w-14 h-14 rounded-2xl bg-[#5865F2] flex items-center justify-center btn-pop">
              <Loader2 className="w-7 h-7 text-white animate-spin" />
            </div>
            <p className="text-slate-700 font-mono text-sm">Connecting your Discord…</p>
          </>
        ) : (
          <p className="text-rose-600 font-semibold">Discord sign-in failed. Redirecting…</p>
        )}
      </div>
    </div>
  );
}
